import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ExternalLink } from "lucide-react";

export function PublicHeader() {
  return (
    <header className="sticky top-0 z-30 backdrop-blur bg-[#012A42]/95 border-b border-white/10">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="public-logo"><Logo theme="dark" size={26} /></Link>
        <div className="flex items-center gap-2">
          <Link to="/login"><Button variant="ghost" data-testid="public-signin" className="text-white hover:bg-white/10">Sign In</Button></Link>
          <Link to="/register"><Button data-testid="public-create-account" className="bg-[#0D9488] hover:bg-[#0b7d72] text-white rounded-full px-5">Create My Account</Button></Link>
        </div>
      </div>
    </header>
  );
}

export function DisclaimerNotice({ disclaimer, tone = "light" }) {
  if (!disclaimer) return null;
  const dark = tone === "dark";
  return (
    <div data-testid="public-disclaimer"
      className={`rounded-xl border px-5 py-4 text-xs leading-relaxed ${dark ? "border-white/15 bg-white/5 text-white/70" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
      <div className="flex items-center gap-2 font-semibold mb-1.5 uppercase tracking-wide">
        <ShieldAlert className="w-4 h-4" /> {disclaimer.title}
      </div>
      <p>{disclaimer.body}</p>
      {disclaimer.farmers_links && (
        <div className="mt-2.5 flex flex-wrap gap-x-5 gap-y-1">
          <a href={disclaimer.farmers_links.houston} target="_blank" rel="noopener noreferrer"
            className={`inline-flex items-center gap-1 font-medium hover:underline ${dark ? "text-brand-cyan" : "text-[#006090]"}`}>
            Official Farmers recruiting profile — Houston <ExternalLink className="w-3 h-3" />
          </a>
          <a href={disclaimer.farmers_links.california} target="_blank" rel="noopener noreferrer"
            className={`inline-flex items-center gap-1 font-medium hover:underline ${dark ? "text-brand-cyan" : "text-[#006090]"}`}>
            Official Farmers recruiting profile — California <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      )}
    </div>
  );
}

export function PublicFooter({ disclaimer }) {
  return (
    <footer className="bg-[#012A42] text-white/70 mt-20">
      <div className="max-w-6xl mx-auto px-6 py-12 space-y-8">
        <DisclaimerNotice disclaimer={disclaimer} tone="dark" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs border-t border-white/10 pt-6">
          <Logo theme="dark" size={22} />
          <p>© {new Date().getFullYear()} Top-Recruit · Careers in Insurance & Financial Services</p>
          <div className="flex gap-4">
            <Link to="/login" className="hover:text-white">Sign In</Link>
            <Link to="/register" className="hover:text-white">Create Account</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
